/**
 * @file cef 客户端
 * @author zhujialu
 */
define(function (require, exports, module) {
    'use strict'

    var cef = BJY.cef
    var auth = BJY.auth
    var eventEmitter = BJY.eventEmitter

    var language = require('../language/main')

    eventEmitter
        .on(eventEmitter.CLIENT_INIT_FAIL, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.ERROR_RUN_CEF_FAIL
            })
        })
        .on(eventEmitter.LOCAL_RECORD_ERROR, function (e, data) {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: data.content
            })
        })
        .on(eventEmitter.PUSH_RECORD_ERROR, function (e, data) {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: data.content
            })
        })
        .on(eventEmitter.RECORD_FAIL_BY_DISK_NOT_ENOUGH, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH
            })
        })
        .on(eventEmitter.MIC_OPEN_FAIL, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_OPEN_MIC
            })
        })
        .on(eventEmitter.CREATE_STREAM_TIMEOUT, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.ALERT_CREATE_STREAM_TIMEOUT
            })
        })
        .on(eventEmitter.SPEAKER_OPEN_FAIL, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_OPEN_SPEAKER
            })
        })
        .on(eventEmitter.MIC_CAPTURE_FAIL, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_CAPTURE_AUDIO
            })
        })
        .on(eventEmitter.AUDIO_PLAYBACK_ERROR, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_PLAYBACK_AUDIO
            })
        })
        .on(eventEmitter.CAMERA_OPEN_FAIL, function () {
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_CAMERA_IS_BUSY
            })
        })
        .on(eventEmitter.CLIENT_UPGRADE_TRIGGER, function (e, data) {
            confirm({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CONFIRM_UPGRADE_BEFORE_USE,
                noClose: true,
                buttons: [
                    {
                        text: language.LABEL_UPDATE_CLIENT_VERSION,
                        type: 'primary',
                        handler: function () {
                            window.open(data.url)
                        }
                    },
                    {
                        text: language.LABEL_CLOSE,
                        handler: function () {
                            eventEmitter.trigger(eventEmitter.CLIENT_SHUTDOWN_TRIGGER)
                        }
                    }
                ]
            })
        })
        .on(eventEmitter.MIC_RENDER_ABORTED, function () {
            eventEmitter.trigger(eventEmitter.MEDIA_SWITCH_TRIGGER, {
                audioOn: false
            })
            alert({
                title: language.ALERT_DEFAULT_TITLE,
                content: language.CEF_ERROR_WORK_MIC
            })
        })
        .on(eventEmitter.PUBLISH_ERROR, function (e, data) {
            alert({
                title: language.COMFIRM_INFO_TIP,
                content: language.PUBLISH_ERROR,
                buttons: [
                    {
                        text: language.BUTTON_REFRESH,
                        type: 'primary',
                        action: function () {
                            this.hide()
                            location.reload()
                        }
                    },
                    {
                        text: language.BUTTON_CANCEL,
                        type: 'default',
                        action: function () {
                            this.hide()
                        }
                    }
                ]
            })
        })

    return cef
})
